<template>
  <div>
    <div v-for="(block, index) in blocks" :key="index">
      <component :is="block.typeHandle" v-if="isVisible(block)" v-bind="{ ...block, blockPosition: index }" />
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import guestComponent from '@/mixins/guestComponent';

import Exercise, { ExercisesBlocksExerciseFragment } from '@/components/common/blocks/Exercise';
import ExerciseByProductSlider, {
  ExercisesBlocksExerciseByProductSliderFragment,
} from '@/components/common/blocks/ExercisesByProductSlider';
import LargeExerciseRoutineSlider, {
  ExercisesBlocksLargeExerciseRoutineSliderFragment,
} from '@/components/common/blocks/LargeExerciseRoutineSlider';
import RoutineCardsSlider, {
  MarketingBlocksRoutineCardsSliderFragment,
} from '@/components/common/blocks/RoutineCardsSlider';
import RoutinesSportSlider, {
  ExercisesBlocksRoutinesSportSliderFragment,
} from '@/components/common/blocks/RoutinesSportSlider';
import RoutineFiftyFiftyTeaserWithBullets, {
  ExercisesBlocksRoutineFiftyFiftyTeaserWithBulletsFragment,
} from '@/components/common/blocks/RoutineFiftyFiftyTeaserWithBullets';
import FullWidthTeaserBox, {
  MarketingBlocksFullWidthTeaserBoxFragment,
} from '@/components/common/blocks/FullWidthTeaserBox';
import AppCta, { MarketingBlocksAppCtaFragment } from '@/components/common/blocks/AppCta';
import SmallTopicFeatureBars, { SmallTopicFeatureBarsFragment } from '@/components/common/blocks/SmallTopicFeatureBars';
import FullwidthTopicFeatureBars, {
  ExercisesBlocksFullwidthTopicFeatureBarsFragment,
} from '@/components/common/blocks/FullwidthTopicFeatureBars';
import ContentRecommendationSlide, {
  StoriesPageBlocksContentRecommendationSlideFragment,
} from '@/components/common/blocks/ContentRecommendationSlide';
import ExerciseRoutineCardsSliderWithText, {
  MarketingBlocksRoutineCardsSliderWithTextFragment,
} from '@/components/common/blocks/ExerciseRoutineCardsSliderWithText';
import ImageTitleFeature, { ShopBlocksImageTitleFeatureFragment } from '@/components/common/blocks/ImageTitleFeature';
import ProductSlider, { MarketingBlocksProductSliderFragment } from '@/components/common/blocks/ProductSlider';
import FiftyFiftyTeaserWithBullets, {
  ExercisesBlocksFiftyFiftyTeaserWithBulletsFragment,
} from '@/components/common/blocks/FiftyFiftyTeaserWithBullets';
import ArticleRowSlide, { MarketingBlocksArticleRowSlideFragment } from '@/components/common/blocks/ArticleRowSlide';
import VideoWithDescription, {
  ExercisesBlocksVideoWithDescriptionFragment,
} from '@/components/common/blocks/VideoWithDescription';
import GenericIframe, { MarketingBlocksGenericIframeFragment } from '@/components/common/blocks/GenericIframe';
import NewsletterSignupForm, {
  MarketingBlocksNewsletterSignupFormFragment,
} from '@/components/common/blocks/NewsletterSignupForm';

export const ExercisesBlocksMatrixFragment = gql`
  fragment ExercisesBlocksMatrixFragment on exercisesBlocks_MatrixField {
    ...ExercisesBlocksExerciseFragment
    ...ExercisesBlocksExerciseByProductSliderFragment
    ...ExercisesBlocksLargeExerciseRoutineSliderFragment
    ...MarketingBlocksRoutineCardsSliderFragment
    ...ExercisesBlocksRoutinesSportSliderFragment
    ...ExercisesBlocksRoutineFiftyFiftyTeaserWithBulletsFragment
    ...MarketingBlocksFullWidthTeaserBoxFragment
    ...MarketingBlocksAppCtaFragment
    ...SmallTopicFeatureBarsFragment
    ...ExercisesBlocksFullwidthTopicFeatureBarsFragment
    ...StoriesPageBlocksContentRecommendationSlideFragment
    ...MarketingBlocksRoutineCardsSliderWithTextFragment
    ...ShopBlocksImageTitleFeatureFragment
    ...MarketingBlocksProductSliderFragment
    ...ExercisesBlocksFiftyFiftyTeaserWithBulletsFragment
    ...MarketingBlocksArticleRowSlideFragment
    ...ExercisesBlocksVideoWithDescriptionFragment
    ...MarketingBlocksGenericIframeFragment
    ...MarketingBlocksNewsletterSignupFormFragment
  }
  ${ExercisesBlocksExerciseFragment}
  ${ExercisesBlocksExerciseByProductSliderFragment}
  ${ExercisesBlocksLargeExerciseRoutineSliderFragment}
  ${MarketingBlocksRoutineCardsSliderFragment}
  ${ExercisesBlocksRoutinesSportSliderFragment}
  ${ExercisesBlocksRoutineFiftyFiftyTeaserWithBulletsFragment}
  ${MarketingBlocksFullWidthTeaserBoxFragment}
  ${MarketingBlocksAppCtaFragment}
  ${SmallTopicFeatureBarsFragment}
  ${ExercisesBlocksFullwidthTopicFeatureBarsFragment}
  ${StoriesPageBlocksContentRecommendationSlideFragment}
  ${MarketingBlocksRoutineCardsSliderWithTextFragment}
  ${ShopBlocksImageTitleFeatureFragment}
  ${MarketingBlocksProductSliderFragment}
  ${ExercisesBlocksFiftyFiftyTeaserWithBulletsFragment}
  ${MarketingBlocksArticleRowSlideFragment}
  ${ExercisesBlocksVideoWithDescriptionFragment}
  ${MarketingBlocksGenericIframeFragment}
  ${MarketingBlocksNewsletterSignupFormFragment}
`;

export default {
  components: {
    GenericIframe,
    Exercise,
    ExerciseByProductSlider,
    LargeExerciseRoutineSlider,
    RoutineCardsSlider,
    RoutinesSportSlider,
    RoutineFiftyFiftyTeaserWithBullets,
    FullWidthTeaserBox,
    AppCta,
    SmallTopicFeatureBars,
    ImageTitleFeature,
    FullwidthTopicFeatureBars,
    ContentRecommendationSlide,
    ExerciseRoutineCardsSliderWithText,
    ProductSlider,
    FiftyFiftyTeaserWithBullets,
    ArticleRowSlide,
    VideoWithDescription,
    NewsletterSignupForm,
  },
  mixins: [guestComponent],
  props: {
    entry: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    blocks() {
      return this.entry?.exercisesBlocks || [];
    },
  },
};
</script>
